import { FC } from 'react';

import classNames from 'classnames';
import { Accept } from 'react-dropzone';
import { twMerge } from 'tailwind-merge';

import { Dropzone } from '@components/index';
import { MAX_RAW_FILE_SIZE } from '@constants/generalConstants';

interface CustomUploaderProps {
  allowableFileExt: Accept;
  maxSize: number;
  onClick: (files: File[]) => void;
  isDisabled?: boolean;
  multiple?: boolean;
  classOverride?: string;
}

export const CustomUploader: FC<CustomUploaderProps> = ({
  allowableFileExt,
  maxSize = MAX_RAW_FILE_SIZE,
  onClick,
  isDisabled = false,
  multiple = true,
  classOverride = '',
}) => {
  return (
    <Dropzone
      accept={allowableFileExt}
      onFilesDrop={onClick}
      multiple={multiple}
      maxSize={maxSize}
    >
      <div
        className={twMerge(
          classNames(
            'flex py-6 justify-center items-center border rounded-lg w-full border-dashed border-gray-4',
            isDisabled ? 'opacity-50' : '',
            classOverride,
          ),
        )}
      >
        <div className="flex gap-2">
          <span className="text-gray-5 pl-2.5">
            Drag and drop files here or{' '}
          </span>
          <button className="underline">Upload</button>
        </div>
      </div>
    </Dropzone>
  );
};
